import React from "react";
import Link from "next/link";
import Meta from "../Meta";
import Icon from "../components/Icon";
import Button from "../components/Button";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const styles = `
.t26-404 {
  min-height: 60vh;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: clamp(40px, 8vw, 120px) clamp(20px, 4vw, 32px);
  text-align: center;
}
.t26-404__code {
  font-family: var(--font-display);
  font-size: clamp(80px, 14vw, 180px);
  font-weight: 700;
  line-height: 1;
  color: var(--primary);
  letter-spacing: -.03em;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.t26-404__title {
  font-family: var(--font-display);
  font-size: clamp(24px, 4vw, 40px);
  font-weight: 700;
  color: var(--ink);
  margin: 16px 0 0;
}
.t26-404__desc {
  font-size: 16px;
  color: var(--ink-3);
  margin: 12px 0 24px;
  max-width: 44ch;
}
`;

export default function Page404({ context }) {
    const { org } = context;
    return (
        <>
            <Meta context={context} title={t`Page introuvable`} description={t`Désolé, cette page n'existe pas.`} noindex />
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-404">
                <div className="t26-404__code">404</div>
                <h1 className="t26-404__title"><Trans>Page introuvable</Trans></h1>
                <p className="t26-404__desc">
                    <Trans>La page que vous cherchez n'existe pas ou a été déplacée.</Trans>
                </p>
                <Link href={org.BASE_WEB_URL}>
                    <Button variant="primary" size="lg" as="span">
                        <Icon name="arrowRight" size={16} className="t26-flip-rtl" style={{ transform: "scaleX(-1)" }} />
                        <Trans>Retour à l'accueil</Trans>
                    </Button>
                </Link>
            </div>
        </>
    );
}
